import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';

export const useCloseFeedback = (url, csrfToken) => {
  const [response, setResponse] = useState([]);
  const role = useSelector(state => state.role);
  const [payload, setPayload] = useState({
    "status": "A",
    "departmentId": String(role.userCurrRole.department.id),
  });

  const headers = {
    'Content-Type': 'application/json',
    'X-CSRF-TOKEN': csrfToken,
  };

  const getCloseFeedback = useCallback(() => {
    axios.post(url,JSON.stringify(payload), {
      withCredentials: true,
      headers,
    })
      .then((data) => {
        console.log(data);
        setResponse(data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [url, headers]);

  useEffect(() => {
    getCloseFeedback();
  }, []);

  return response;
};


